import { render, staticRenderFns } from "./data-item.vue?vue&type=template&id=055dbb00&scoped=true&"
import script from "./data-item.vue?vue&type=script&lang=js&"
export * from "./data-item.vue?vue&type=script&lang=js&"
import style0 from "./data-item.vue?vue&type=style&index=0&id=055dbb00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055dbb00",
  null
  
)

export default component.exports